import { Routes } from '@angular/router';

import { roomAccessGuard } from './shared/guards/room-access.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'join/:invitationCode',
    canActivate: [roomAccessGuard],
    // Guard redirects before any component loads — no component needed here.
    children: [],
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
